import { LogLevel } from "../app/shared/service/logging/log-level.model";

export const environment = {
  production: false,
  logLevel: LogLevel.DEBUG,
  apiUrl: "https://konsulentskolen-dev-api.azurewebsites.net",
  clientUrl: "https://konsulentskolen-dev-client.azurewebsites.net",
  blobStoreUrl: "https://konsulentskolendevstore.blob.core.windows.net",
  applicationInsightsKey: "c7dd52ae-69cb-4b7a-a035-2f4f7e5210f4",
  googleAnalyticsCode: "UA-126067502-1",

  // Feature flag for Waiting List feature
  // TODO: Remove flag and adjust event.component.ts and event.component.html when waitingList is stable
  enableWaitingList: false,

  firebaseConfig: {
    apiKey: "AIzaSyD6ZDtcRepNthV9LEd5j-AZ-ez78qVaDTA",
    authDomain: "konsulentskolen-dev-83783.firebaseapp.com",
    projectId: "konsulentskolen-dev-83783",
    storageBucket: "konsulentskolen-dev-83783.firebasestorage.app",
    messagingSenderId: "279329579845",
    appId: "1:279329579845:web:113fdd56127e0f9ca2142c",
    measurementId: "G-PBGGMW9F1N",
  },

  microsoftProviderConfig: {
    provider: "microsoft.com",
    tenant: "capgemini.onmicrosoft.com",
    scopes: ["User.Read"],
  },
};
